import React, { createContext } from 'react';
import type { Study } from './fetchData';

export const AnalyticsContext = createContext<{ id: string; sessionId: string }>({
    id: '',
    sessionId: '',
});
export const CloseDialogContext = createContext<{ close: () => unknown }>({
    close: () => {},
});
export const MetadataContext = createContext<{ demoMode: boolean; fullPage: boolean }>({
    demoMode: false,
    fullPage: false,
});

type Props = {
    children: React.ReactNode;
    study: Study;
    analyticsId: string;
    sessionId: string;
    close: () => void;
    demoMode: boolean;
    fullPage: boolean;
};

const ContextWrapper = ({ children, analyticsId, close, demoMode, fullPage, sessionId }: Props) => {
    return (
        <AnalyticsContext.Provider value={{ id: analyticsId, sessionId }}>
            <CloseDialogContext.Provider value={{ close }}>
                <MetadataContext.Provider value={{ demoMode, fullPage }}>
                    {children}
                </MetadataContext.Provider>
            </CloseDialogContext.Provider>
        </AnalyticsContext.Provider>
    );
};

export default ContextWrapper;
